module.exports = __webpack_public_path__ + "img/verneplanforvassdrag.0aed2319.jpg";